import { h, Component, Fragment } from 'preact';

export default class FooterComponent extends Component {
    constructor() {
        super();
        this.state = {
        };
        this.leftLinks = [
            { link: "http://www.doc.gov", label: "United States Department of Commerce" },
            { link: "http://www.noaa.gov", label: "National Oceanic and Atmospheric Administration" },
            { link: "http://oceanservice.noaa.gov", label: "National Ocean Service" },
            { link: "//coast.noaa.gov", label: "Website owner: Office for Coastal Management" }
            // { link: "//coast.noaa.gov", label: "Last Modified: N/A" } // TODO why does this duplicate link exist?
        ];
        this.rightLinks = [
            { link: "https://coast.noaa.gov/contactform/", label: "Contact Us" },
            { link: "https://coast.noaa.gov/PrivacyPolicy/privacyPolicy.html", label: "Privacy Policy" },
            { link: "http://www.noaa.gov/disclaimer.html", label: "Link Disclaimer" },
            { link: "http://usa.gov", label: "USA.gov" }
        ];
    }

    render() {
        const self = this;
        return (
            <Fragment>
                <div class="footer">
                    <p class="float-left pad-mid">
                        {
                            self.leftLinks.map((item, index) => {
                                const arr = [<a href={item.link} target="_blank" rel="noreferrer">{item.label}</a>, <span> | </span>];
                                return arr;
                            })
                        }
                        <span>Last Modified: <span id="ocm_frontend_last_modified"></span></span>
                    </p>
                    <p class="float-right pad-mid footer-right-content">
                        {
                            self.rightLinks.map((item, index) => {
                                const arr = [<a href={item.link} target="_blank" rel="noreferrer">{item.label}</a>];
                                if (index < self.rightLinks.length - 1) {
                                    arr.push(<span> | </span>);
                                }
                                return arr;
                            })
                        }
                    </p>
                </div>
            </Fragment>
        );
    }
}
